import { StaticLoginModalHost } from '@/components/auth/StaticLoginModalHost';
import { ClientVersionProbe } from '@/components/common/ClientVersionProbe';
import { WebMarketingAttributionRuntime } from '@/components/marketing/WebMarketingAttributionCapture';

import type { AppProps } from 'next/app';
import { useMemo } from 'react';
import { pagesLoginQueryRouter } from '@/lib/auth/login-dialog';

import '@/app/globals.css';

export default function PagesApp({ Component, pageProps, router }: AppProps) {
  const queryRouter = useMemo(() => pagesLoginQueryRouter(router), [router]);
  const url = new URL(router.asPath, 'https://www.dobidobi.ai');
  return <>
    <Component {...pageProps} />
    <ClientVersionProbe />
    {router.isReady && <WebMarketingAttributionRuntime pathname={url.pathname} query={url.searchParams.toString()} />}
    <StaticLoginModalHost key={pageProps.locale ?? 'en'} locale={pageProps.locale} messages={pageProps.loginMessages} queryRouter={queryRouter} />
  </>;
}
